import React from "react";
import { ChevronDownIcon, ChevronUpIcon } from "@heroicons/react/20/solid";
import { clsx } from "clsx";

function SortIcon({ sort, field }) {
  const iconClassName = "h-4 w-4 flex-none transition-all duration-300";

  return (
    <span
      className={clsx(
        "ms-2 flex-none rounded-lg transition-all duration-300 p-0.5",
        sort.field === field
          ? "bg-slate-100 text-primary-600"
          : "invisible group-hover:visible bg-slate-50 text-slate-400",
      )}
    >
      {sort.isAscending ? (
        <ChevronDownIcon className={iconClassName} aria-hidden="true" />
      ) : (
        <ChevronUpIcon className={iconClassName} aria-hidden="true" />
      )}
    </span>
  );
}

export default SortIcon;
